import apiFetch from '../apiFetch'

export default function (token, filter, metadatoId) {
  return apiFetch({ endPoint: `Metadata/${metadatoId}/List`, method: 'POST', body: filter, token: token })
}
